import { CellViewModel } from '../../../../lib/components/compound/table/viewModels/cell';
import { ReceiptsRowViewModel } from '../row/viewModel';

export abstract class ReceiptsCellViewModel extends CellViewModel {
  constructor(protected row: ReceiptsRowViewModel) {
    super();
  }

  get receipt() {
    return this.row.receipt;
  }
}
